import { Link } from "react-router";
import { handleOpenChat } from "utils/analytics";

export default function Footer() {
  return (
    <div className="w-full px-5 lg:px-10 py-5 bg-gray-50 border border-gray-100 bg-top">
      <footer className="flex justify-around flex-wrap max-w-screen-xl mx-auto">
        <div className="w-80 p-5">
          <p className="mb-2">Endereço</p>
          <p className="font-light">Rod AL 101 Norte </p>
          <p className="font-light">Praia de Peroba</p>
          <p className="font-light">Maragogi - Alagoas</p>
        </div>
        <div className="w-80 p-5 flex flex-col">
          <p className="mb-2">Atrações</p>
          <Link className="font-light" to="/piscinas-naturais">
            Piscinas Naturais
          </Link>
          <Link className="font-light" to="/passeio-de-orla">
            Passeio de Orla
          </Link>
          <Link className="font-light" to="/jetski">
            Jet Ski
          </Link>
          <Link className="font-light" to="/boat">
            Banana Boat
          </Link>
          <Link className="font-light" to="/boat">
            Disco Boat
          </Link>
        </div>
        <div className="w-80 p-5">
          <p className="mb-2">Fale conosco</p>
          <p className="font-light">reservas@meucaribe.com.br</p>
          <p className="font-light">wa.me/5581981211006</p>
          <p className="font-light">+55 (82) 99381-2224</p>
        </div>
        <div className="w-80 p-5">
            <p className="mb-2">Segue a gente</p>
            <div className="flex">
              <a href="https://www.instagram.com/meucaribe">
                <img className="h-8 mr-8" src="/insta.png" alt="Meu Caribe" />
              </a>
              <button onClick={handleOpenChat} type="button">
                <img className="h-8" src="/wpp.png" alt="Meu Caribe" />
              </button>
            </div>
        </div>
      </footer>
    </div>
  )
}